import $ from 'jquery';
import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    marginTop: "15%"
  },
});

export default function BrowserView(props) {
  const classes = useStyles();
  const { user } = props;
  const [autoRenew, setAutoRenew] = React.useState(user.subscription.is_active);
  const [loading, setLoading] = React.useState(false);

  const handleSubscriptionChange = event => {
    setLoading(true);
    const { checked } = event.target;
    const url = autoRenew ? '/billing/unsubscribe' : '/billing/subscribe';

    $.ajax({
      url,
      method: 'POST',
      success: () => { setAutoRenew(checked); setLoading(false) }
    });
  };

  const lastPaymentDate = new Date(user.subscription.last_payment_date);
  let nextPaymentDate = new Date(
    lastPaymentDate.setMonth(lastPaymentDate.getMonth() + 1)
  );
  nextPaymentDate = nextPaymentDate.toLocaleDateString();

  let valid_till = new Date(user.subscription.valid_till);
  valid_till = valid_till.toLocaleDateString();
  return (
    <Container maxWidth="sm" component="main">
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Typography variant="h5" component="h2">
            {user.username}
          </Typography>
          <Divider style={{ marginTop: 20, marginBottom: 20 }} />
          <Typography color="textSecondary">
            {`Balance: ${user.balance}`}
          </Typography>
          <Typography color="textSecondary">
            {`Bonus: $${user.referral_balance}`}
          </Typography>
          {
            user.subscription.plan && <div>
              <Typography variant="body2" component="p" style={{ marginTop: 20 }} >
                You have purchased the plan {user.subscription.plan}, which expires on {valid_till}.
              </Typography>
              <Typography variant="body2" component="p">
                Please note that all coins on your account will be nullified after the mentioned date.
              </Typography>
            </div>
          }
        </CardContent>
      </Card>
    </Container>
  );
}